/**
 * Based off of https://github.com/lindenlab/extraction-tools/blob/master/web/src/components/Money/useCurrencyFormatter.js
 */

import { useMemo } from "react";
import { useSettings } from "utils/settingsContext";
import getRawCurrencyValue from "./getRawCurrencyValue";

/**
 * Returns a formatter function which accepts a Tilia currency display value  as a Number,
 * Number, or string, and returns the raw value that can be used for API and internal purposes.
 *
 * @param {string} currency
 * @returns {function(value: Number|string): string}
 */
function useGetRawCurrencyValue(currency) {
  const { integratorSettings } = useSettings();

  return useMemo(() => {
    return getRawCurrencyValue(currency, integratorSettings?.virtualCurrencies?.currencies || {});
  }, [currency, integratorSettings?.virtualCurrencies]);
}

export default useGetRawCurrencyValue;
